<template>
    <v-container fluid>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :top="true"
        :right="true"
        :timeout="6000"
        absolute
      >
        {{ message }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          CLOSE
        </v-btn>
      </v-snackbar>
      <v-layout mt-5>
        <v-flex xs12>
          <div :class="paginatedItems.length === 5 ? 'warrant_box' : 'warrant_box_empty'">
            <v-card-text>
              <v-layout>
                <v-flex xs3>
                  <span class="accent--text" style="font-size: 14px; font-weight:700;"> Holding Warrants </span>
                </v-flex>
                <v-spacer>
                </v-spacer>
              
  <v-text-field
                  v-model="search"
                  label="Search Warrants"
                  @input="handleSearchInput"
                  class="search-input"
                  style="max-width: 300px; margin: 0; padding: 0"
                ></v-text-field>
              </v-layout>
              <table class="table">
                <thead class="thead">
                <tr>
                  <th scope="col">Outturn</th>
                  <th scope="col">Mark</th>
                  <th scope="col">Grade</th>
                  <th scope="col">Split Number</th>
                  <th scope="col">Bags</th>
                  <th scope="col">Pockets</th>
                  <th scope="col">Weight</th>
                  <th scope="col">Broker</th>
                  <th scope="col">Warehouse Checker</th>
                  <th scope="col">Warrant Number</th>
                  <th scope="col">Status</th>
                  <!-- <th scope="col">Sale Number</th> -->
                  <th scope="col">Season</th>
                  <th scope="col">Date</th>
                  <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                  
                <tr v-for="item in filteredList" v-bind:key="item.id">
                  
                  <td> {{ item.outturnNumber }} </td>
                  <td> {{ item.marks }} </td>
                  <td> {{ item.grade }} </td>
                  <td> {{ item.splitNumber }} </td>
                  <td> {{ item.bags }} </td>
                  <td> {{ item.pockets }} </td>
                  <td> {{ item.netWeight }} </td>
                  <td> {{ item.brokerCode }}</td>
                  <td> {{ item.whChecker }}</td>
                  <td> {{ item.warrantNumber }}</td>
                  <td> {{ item.statusName }}</td>
                  <!-- <td> {{ item.saleNumber}}</td> -->
                  <td> {{ item.season }}</td>
                  <td> {{ item.dateUpdated | prettyDate }}</td>
                  <td class="actions">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          v-on="on"
                          text
                          icon
                          
                        >
                          <v-icon small> more_horiz </v-icon>
                        </v-btn>
                      </template>
                      <v-list v-if="canBeDownloaded(item)">
                        <v-list-item @click="downloadWarrant(item)">
                          <v-list-item-title> Download </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
                </tbody>
              </table>
            </v-card-text>
            <v-card-actions>
              <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
              <v-spacer></v-spacer>
              <v-pagination
                v-model="page"
                :length="numberOfLinks"
                :total-visible="7"
                color="secondary"
                class="accent--text logoutbtn"
              ></v-pagination>
            </v-card-actions>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  <script>
  import axios from 'axios'
  import config from '../../../config'
  import store from '../../../store'
  export default {
    name: 'viewwarrant',
    data: function () {
      return {
        warrants: [],
        message: '',
        loading: false,
        snackbar: false,
        snackbarColor: '',
        messsage: '',
        permissions: [],
        paginatedItems: [],
        numberOfLinks: 0,
        numberOfItemsPerPage: 6,
        page: 1,
        search: '',
        currentPage: 0,
        searchQuery:'',
      }
    },
    watch: {
      search(val) {
        if (val === '') {
          this.getWarrants(this.currentPage);
        }},
      warrants: function () {
        this.paginatedItems = this.warrants
        // this.numberOfLinks = Math.ceil(this.warrants.length / this.numberOfItemsPerPage)
        // this.paginatedItems = this.paginationMethod(this.warrants, 1, this.numberOfItemsPerPage)
      },
      page: function (val) {
        this.paginatedItems = this.getWarrants(val - 1)
        // this.paginatedItems = this.paginationMethod(this.warrants, val, this.numberOfItemsPerPage)
      }
    },
    mounted () {
      this.getWarrants(this.currentPage)
      this.numberOfLinks = Math.ceil(this.warrants.length / this.numberOfItemsPerPage)
      this.permissions = store.state.user.roleId.permissions
    },
    computed: {
      filteredList: function () {
  
        return this.paginatedItems
      }
    },
    methods: {
      handleSearchInput() {
        if (this.search.trim() === '') {
          this.getWarrants(this.page-1);
        }else{
          console.log('Search Query')
          this.searchWarrants(); // Call search method on input
        }
      },
  
      paginationMethod (items, pageNumber, limitPerPage) {
        pageNumber = pageNumber - 1
        const from = pageNumber * limitPerPage
        let to = (pageNumber + 1) * limitPerPage
        if (to >= items.length) {
          to = items.length
        }
        return items.slice(from, to)
      },
      getWarrants (page) {
        const url = config.serverURI + '/warrant/holding?page=' + page + '&size=' + this.numberOfItemsPerPage + '&paginate=Y'
        console.log('page',page)
        console.log('size',page)
        axios.get(url)
          .then(response => {
            console.log('Response...',response.data)
           
  
            this.warrants = response.data.content
            this.totalWarrants = this.warrants.length
  
            this.numberOfLinks = response.data.page.totalPages
                      this.numberOfItemsPerPage = response.data.page.size
                      this.currentPage = response.page.number
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            this.message = error.response.status
            this.snackbar = true
            this.snackbarColor = 'error'
          })
        return this.warrants
      },
      searchWarrants() {
        console.log('Item to',this.search)
        
        const url = config.serverURI +'/warrant/holding/search?query=' + this.search
        axios.get(url)
          .then(response => {
            console.log('Response',response.data.content)
            this.warrants = response.data.content
            this.totalWarrants = this.warrants.length
            this.numberOfLinks = response.data.page.totalPages
            this.numberOfItemsPerPage = response.data.page.size
            this.currentPage = response.data.page.number
          })
          .catch(error => {
            this.message = error.response?.status ?? 'Error occurred'
            this.snackbar = true
            this.snackbarColor = 'error'
          })
      },
      canBeApproved1 (item) {
        return item.warrantNumber != null && item.approver1 == null && this.hasPerm('CAN_CONFIRM_WARRANT')
      },
      canBeApproved2 (item) {
        return item.approver1 != null && item.approver2 == null && this.hasPerm('CAN_CONFIRM_WARRANT')
      },
      hasPerm (permission) {
        return this.permissions.includes(permission)
      },
      canBeDownloaded (item) {
			return item.warrantNumber != null 
      // && item.whChecker !== null 
      // && this.hasPerm('CAN_CONFIRM_WARRANT')
		},
      approveAction (item) {
        this.approveloading = true
        const url = config.serverURI + '/warrant/approve'
        console.log('calling ' + url)
        axios.post(url, item)
          .then(response => {
            this.approveloading = false
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbar = true
              this.snackbarColor = 'error'
              return
            }
            this.getWarrants(this.currentPage)
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'primary'
          })
          .catch(error => {
            console.log('error', error.response)
            this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
            this.snackbar = true
            this.snackbarColor = 'error'
            this.approveloading = false
          })
        this.confirmDialog = false
      },
      downloadWarrant (item) {
			const url = config.serverURI + '/warrant/download/holding'
			axios({ url: url, method: 'POST', responseType: 'blob', data: item })
				.then(response => {
					
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
					const link = document.createElement('a')
					link.href = url
					const output_string = item.season.replace("/", "")
					const itemFileName = output_string +'_'+item.saleNumber+'_'+item.outTurnNumber+'_'+item.warrantNumber+ '.pdf'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
    }
  }
  
  </script>
  <style>
  .warrant_box_empty {
    position: relative;
    background: #fff;
    border: 1px solid #707070;
  }
  .warrant_box {
    position: relative;
    background: #fff;
    border: 1px solid #707070;
  }
  .warrant_box:after, .warrant_box:before {
    right: 100%;
    top: 90%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  
  .warrant_box:after {
    border-color: rgba(255, 255, 255, 0);
    border-right-color: #fff;
    border-width: 20px;
    margin-top: -20px;
  }
  .warrant_box:before {
    border-color: rgba(112, 112, 112, 0);
    border-right-color: #707070;
    border-width: 21px;
    margin-top: -21px;
  }
  </style>
  